export default __webpack_public_path__ + "static/media/Solfeggio-description-ar.2792eee4.png";